// extracted by mini-css-extract-plugin
module.exports = {"Stack":"styles_Stack__2fREn"};